import useHeaderCoordinates from 'hooks/useHeaderCoordinates';
import { SidebarPaidPlacementAd, SidebarPaidPlacementContainer } from './SidebarPaidPlacementStyles';

interface SidebarPaidPlacementProps {
  children: React.ReactNode;
}

const SidebarPaidPlacement = ({ children }: SidebarPaidPlacementProps) => {
  const { bottom } = useHeaderCoordinates();

  return (
    <SidebarPaidPlacementContainer>
      <SidebarPaidPlacementAd $stickyTop={bottom}>{children}</SidebarPaidPlacementAd>
    </SidebarPaidPlacementContainer>
  );
};

export default SidebarPaidPlacement;
